import React from 'react'
import { CiSearch } from 'react-icons/ci'
import { HiMagnifyingGlassCircle } from 'react-icons/hi2'
import { NavigateFunction } from 'react-router-dom'

import { UserCode } from '../api/services/user_assignment_codes/types.ts'

type TableColumn = {
  header: string
  accessor: string
  render?: (data: UserCode) => JSX.Element
  className?: string
  classNameTd?: string
  sorted?: boolean
  onClick?: (row: UserCode) => JSX.Element | null
}

export const setAssignmentCodesTableColumns = (
  mainCodeId: number,
  surveys_enabled?: boolean
) => {
  const columns: TableColumn[] = [
    {
      header: 'Kod',
      accessor: 'name',
      render: (row: UserCode) => <>{row.code}</>,
      className: 'w-[150px] xl:w-auto'
    },
    {
      header: 'Opis',
      accessor: 'status',
      render: (row: UserCode) => <>{row.description} </>,
      className: 'w-[120px] xl:w-auto'
    },
    {
      header: 'Ważny od',
      accessor: 'status',
      render: (row: UserCode) => <>{row.valid_from} </>,
      className: 'w-[120px] xl:w-auto'
    },
    {
      header: 'Ważny do',
      accessor: 'status',
      render: (row: UserCode) =>
        row.id !== mainCodeId ? (
          <>{row.valid_until} </>
        ) : (
          <span className="font-bold text-green-500">{'bezterminowo'}</span>
        ),
      className: 'w-[120px] xl:w-auto'
    },
    {
      header: 'Zarejestrowani pacjenci',
      accessor: 'patient_count',
      render: (row: UserCode) => <>{row.patient_count}</>,
      className: 'w-[120px] xl:w-auto',
      classNameTd: 'text-center'
    },
    {
      header: 'Liczba zamówień',
      accessor: 'orders_count',
      render: (row: UserCode) => <>{row.orders_count}</>,
      className: 'w-[120px] xl:w-auto',
      classNameTd: 'text-center'
    },
    {
      header: 'Cennik',
      accessor: 'special_pricing',
      render: (row: UserCode) => (
        <>
          {row.special_pricing ? (
            <div className="flex justify-center items-center h-full w-full">
              <HiMagnifyingGlassCircle size={32} className="text-green-500" />
            </div>
          ) : null}
        </>
      ),
      className: 'text-center w-[100px]',
      classNameTd: 'text-center',
      onClick: (row: UserCode) => {
        if (row.special_pricing) {
          const pStyles =
            'flex-1 text-center p-2 border-2 dark:bg-gray-800 dark:border-strokedark'
          return (
            <div className="flex flex-col w-full dark:bg-gray-800 dark:border-strokedark">
              <h2>
                Cennik dla kodu: <span className="font-bold">{row.code}</span>
              </h2>
              <div className="flex flex-1 flex-col w-full border-2 mt-2 text-sm">
                <div className="flex flex-1 flex-shrink-0 flex-row justify-between border-b-2 bg-gray-100 w-full dark:bg-gray-950 dark:border-strokedark">
                  <p className={pStyles}>30 dni</p>
                  <p className={pStyles}>90 dni</p>
                  <p className={pStyles}>180 dni</p>
                  <p className={pStyles}>360 dni</p>
                </div>

                <div className="flex flex-row justify-between w-full">
                  <p className={pStyles}>
                    {row.special_pricing.month_diet_price}
                  </p>
                  <p className={pStyles}>
                    {row.special_pricing.three_month_diet_price}
                  </p>
                  <p className={pStyles}>
                    {row.special_pricing.six_month_diet_price}
                  </p>
                  <p className={pStyles}>
                    {row.special_pricing.twelve_month_diet_price}
                  </p>
                </div>
              </div>
            </div>
          )
        } else {
          return null
        }
      }
    }
  ]

  if (surveys_enabled) {
    columns.push({
      header: 'Ankiety',
      accessor: 'survey_templates',
      render: (row: UserCode) => <>{row.survey_templates.length}</>,
      className: 'text-center w-[80px]',
      classNameTd: 'text-center'
    })
  }

  return columns
}

export const setAssignmentCodesTableActions = (
  navigate: NavigateFunction,
  mainCodeId: number
) => {
  return [
    {
      label: 'Podgląd',
      icon: <CiSearch className="text-lg" />,
      onClick: (row: UserCode) => {
        navigate(`/application/assignment-codes/${row.id}/`, {
          state: {
            mainCodeId
          }
        })
      },
      className: 'text-blue-500 pb-1'
    }
  ]
}
